export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getPaginatedOrders(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/order/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteOrder(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/order/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        uploadInvoice(_, data) {
            let formData = new FormData();
            formData.append('image', data.image)
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/order/invoice/" + data.identifier, formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateCustomerNote(_, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/order/customer_note/" + data.identifier, {
                    note: data.note
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateAdminNote(_, data) {
            console.log(data)
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/order/admin_note/" + data.identifier, {
                    note: data.note
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        changeStatus(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/order/status/" + data.id, {
                    status: data.status
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        // toggleOrderStatus(_, identifier) {
        //
        // },
    },
}

